var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFilterAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 7C4.5 6.44772 4.94772 6 5.5 6H19.5C20.0523 6 20.5 6.44772 20.5 7C20.5 7.55228 20.0523 8 19.5 8H5.5C4.94772 8 4.5 7.55228 4.5 7ZM6.5 12C6.5 11.4477 6.94772 11 7.5 11H17.5C18.0523 11 18.5 11.4477 18.5 12C18.5 12.5523 18.0523 13 17.5 13H7.5C6.94772 13 6.5 12.5523 6.5 12ZM8.5 17C8.5 16.4477 8.94772 16 9.5 16H15.5C16.0523 16 16.5 16.4477 16.5 17C16.5 17.5523 16.0523 18 15.5 18H9.5C8.94772 18 8.5 17.5523 8.5 17Z",
    fill: "#202327"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilterAlt);
export default __webpack_public_path__ + "static/media/icon_filter-alt.94267ecda2aba1bbaf82a11e6fecb97b.svg";
export { ForwardRef as ReactComponent };